<h2>Asset Tags</h2>
<div class="tags">
  <div *ngFor="let tag of asset['tags']" (click)="removeTagFromAsset(tag)">{{ tag.category }} - {{ tag.name }}</div>
</div>

<h2>Available Tags</h2>

<div class="available-tags" *ngIf="tagService.tags()">
  <div *ngFor="let tag of tagService.tags()">
    {{ tag.category }} - {{ tag.name }}
    <button (click)="addTagToAsset(tag)">Add</button>
    <button (click)="deleteTag(tag)">Delete</button>
  </div>
</div>

<form [formGroup]="addTagForm" (ngSubmit)="addTag()">
  <app-input-field [control]="addTagForm.controls.category">
    <input type="text" formControlName="category" />
    <label>Tag Category</label>
  </app-input-field>
  <app-input-field [control]="addTagForm.controls.name">
    <input type="text" formControlName="name" />
    <label>Tag Name</label>
  </app-input-field>

  <button>Create tag</button>
</form>
